/**
 * Validates and formats a lead ID to only contain digits
 * @param {string} value - The input value to validate
 * @returns {string} - The formatted lead ID with only digits
 */
export const formatLeadId = (value: string): string => {
  if (!value) return '';
  // Remove all non-digit characters
  return value.replace(/\D/g, '');
};

/**
 * Checks if a lead ID is valid (contains only digits)
 * @param {string} leadId - The lead ID to validate
 * @returns {boolean} - True if valid, false otherwise
 */
export const isValidLeadId = (leadId: string): boolean => {
  if (!leadId) return false;
  // Check if the string contains only digits
  return /^\d+$/.test(leadId);
};

/**
 * Validates and returns error message if invalid
 * @param {string} leadId - The lead ID to validate
 * @returns {string|null} - Error message or null if valid
 */
export const validateLeadId = (leadId: string): string | null => {
  
  if (!/^\d+$/.test(leadId)) {
    return 'Lead ID must contain only digits';
  }
  return null;
};
